<template>
<card>
  <router-link :to="hirerUrl">
    <row-card
    :imageUrl="companyImage"
    :leftTitle="publisherName"
    :leftSubtitle="publishedDate"
    class="row-card" />
  </router-link>
  <div v-if="isSourceJp"  style="padding: 0px 10px">
    <bbob-bbcode  container="div" :plugins="plugins">{{ bbcCodeJobDes }}</bbob-bbcode>
  </div>
  <viewer v-else
    :initialValue="escapeJobDescription"
  />
</card>
</template>

<script>
import Card from '@/components/general/card'
import RowCard from '@/components/general/row-card'
import { Viewer } from '@toast-ui/vue-editor'
import preset from '@bbob/preset-vue'
import {bbCodeJobDescriptionStyles} from '../../helpers/job'

export default {
  components: {
    Card,
    RowCard,
    Viewer
  },
  props: {
    job: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      plugins: [
        preset()
      ]
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.job.hasOwnProperty('source') && this.job.source === 'jp') {
        bbCodeJobDescriptionStyles(document)
      }
    }, 100)
  },
  computed: {
    hirerUrl () {
      return this.$route.meta.hasOwnProperty('widgetMode') ? `/widget/hirer/${this.job.companyId}` : `/hirer/${this.job.companyId}`
    },
    publisherName () {
      return this.job.companyName
    },
    publishedDate () {
      return `${this.$t('jobs.posted')}: ${this.$moment(this.job.createdAt).format('DD MMM YY')}`
    },
    escapeJobDescription: function () {
      if (this.job.description) {
        return this.job.description.replace(/\\/g, '')
      }
      return ''
    },
    bbcCodeJobDes () {
      return this.job.description
    },
    isSourceJp () {
      return this.job.hasOwnProperty('source') && this.job.source === 'jp'
    },
    companyImage () {
      return this.job.companyImageUrl || `/api/identicons/${this.job.companyId}`
    }
  }
}
</script>

<style lang="scss" scoped>
.row-card {
  margin-bottom: 1.5rem;
}
p {
  line-height: 1.57;
  white-space: pre-wrap;
}

.title.is-4 {
  font-size: 1.15rem;
}
a:hover {
  text-decoration: none;
}

.row-card:hover {
  background-color: #d0f0fb;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/job-description-card.vue